
    <div class="prelogin-container">
        <div class="prelogin-card">
            <h1 class="prelogin-title">Login</h1>
            
            <div class="form-group">
                <label class="form-label">Mobile Number</label>
                <input 
                    class="form-input" 
                    type="tel"
                    inputmode="numeric"
                    pattern="[0-9]*"
                    placeholder="Enter your mobile number"
                    [(ngModel)]="preloginData.phone" 
                />
                <div class="form-hint">Example: 4915212345678</div>
            </div>
            
            <div class="form-group">
                <label class="form-label">PIN</label>
                <input 
                    class="form-input" 
                    type="password"
                    inputmode="numeric"
                    pattern="[0-9]*"
                    maxlength="4"
                    placeholder="Enter your 4-digit PIN"
                    (keyup.enter)="preLogin()" 
                    [(ngModel)]="preloginData.pin"
                />
            </div>
            
            <div class="captcha-container">
                <!-- ng7-recaptcha (captchaResponse)="handleCorrectCaptcha($event)" size="invisible" site_key="{{captcha_key}}"></!-->
            </div>
            
            <button class="prelogin-button" (click)="preLogin()" type="submit">
                Login
            </button>
            
            <div class="action-links">
                <button class="register-link" (click)="register()" type="button">
                    Don't have an account? Register
                </button>
            </div>
            
            <ngx-spinner size="medium" [type]="typeSelected"></ngx-spinner>
        </div>
    </div>